import { useIsHomeRolesPending } from "providers/HomeRoleProvider";
import { useAppSelector } from "store/index";
import { selectAvailableHomeRoles, selectLastHomeRole } from "store/selectors";
import { useListSelector } from "store/store-hooks";
import { getDefaultHomeRole } from "utils/home-role";
import { HomeRole, homeUrlForRole } from "utils/urls";

/** Prefer lastHomeRole while roles hydrate; after load, only if still available. */
export const resolveHomeUrl = (
  lastHomeRole: HomeRole | null,
  availableRoles: HomeRole[],
  isHomeRolesPending: boolean,
) => {
  if (lastHomeRole && (isHomeRolesPending || availableRoles.includes(lastHomeRole))) {
    return homeUrlForRole(lastHomeRole);
  }

  return homeUrlForRole(getDefaultHomeRole(availableRoles));
};

export const useHomeUrl = () => {
  const lastHomeRole = useAppSelector(selectLastHomeRole);
  const availableRoles = useListSelector(selectAvailableHomeRoles);
  const isHomeRolesPending = useIsHomeRolesPending();

  return resolveHomeUrl(lastHomeRole, availableRoles, isHomeRolesPending);
};
